import React, { useCallback } from "react";
import { queryCache } from "react-query";
import { makeStyles } from "@material-ui/core";
import LabeledContent from "../../../../components/LabeledContent";
import { QUERY_KEYS } from "../../../../constants";
import { calculateIntakeName } from "../../../../helpers";
import { useWizard } from "../../../wizard/context";
import { useAcademicsSecondaryContext } from "../../pages/AcademicsPageSecondary";
import { ActionBar } from "../../../../components/ActionBar/ActionBar";

const useStyles = makeStyles(() => ({
  labeledContent: {
    "& > :first-child": {
      fontSize: 14,
      color: " #828190",
    },
    "& > :last-child": {
      fontSize: 14,
      color: " #535358",
    },
  },
  intakeContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    minHeight: 74,
    borderBottom: "1px solid rgba(0, 0, 0, 0.05)",
  },
  mainContainer: {
    "& > :last-child": {
      borderBottom: "unset",
    },
  },
}));

const IntakeListItem = ({
  intake, //todo add type
  isDeleteIntakeDisable,
}) => {
  const classes = useStyles();
  const { openWizard } = useWizard();
  const {
    refetchAcademics,
    intakeWizardConfigs: {
      getActivateConfig,
      getDeactivateConfig,
      getDeleteIntakeConfig,
    },
  } = useAcademicsSecondaryContext();

  const { schoolStudentApplications, majorsContainingPrograms } = QUERY_KEYS;

  const changeIntakeStatus = useCallback(async () => {
    if (intake.isActive) {
      (await openWizard(getDeactivateConfig(intake.id))) &&
        (await refetchAcademics());
      queryCache.invalidateQueries([schoolStudentApplications]);
    } else {
      (await openWizard(getActivateConfig(intake.id))) &&
        (await refetchAcademics());
      queryCache.invalidateQueries([schoolStudentApplications]);
    }
  }, [intake]);

  const deleteIntake = useCallback(async () => {
    (await openWizard(getDeleteIntakeConfig(intake.id))) &&
      (await refetchAcademics());
    queryCache.invalidateQueries([majorsContainingPrograms]);
  }, [intake]);

  return (
    <div className={classes.intakeContainer}>
      <LabeledContent className={classes.labeledContent} label={"Intake"}>
        {calculateIntakeName(intake.startDate)}
      </LabeledContent>
      <LabeledContent className={classes.labeledContent} label={"Deadline"}>
        {intake.deadline}
      </LabeledContent>
      <LabeledContent className={classes.labeledContent} label={"Start Date"}>
        {intake.startDate}
      </LabeledContent>
      <ActionBar
        switchCallBack={changeIntakeStatus}
        switchTooltipActive="Deactivate intake"
        switchTooltipNotActive="Activate intake"
        switchState={intake.isActive}
        deleteCallBack={deleteIntake}
        deleteTooltip={"Delete intake"}
        isDeleteDisabled={isDeleteIntakeDisable}
      />
    </div>
  );
};

export const IntakesListSecondary = ({ intakes }) => {
  //todo add type
  const classes = useStyles();

  return (
    <div className={classes.mainContainer}>
      {intakes.map((intake) => (
        <IntakeListItem
          key={intake.id}
          intake={intake}
          isDeleteIntakeDisable={intakes.length === 1}
        />
      ))}
    </div>
  );
};
